// Copyright (c) Docugami, Inc. All rights reserved.
import { SET_NAVIGATION_BAR_VISIBILITY, SET_UPGRADE_ACCOUNT_MODAL_VISIBILITY, SET_UPGRADE_MODAL_DISPLAY_PROPS } from "./types";
import { DisplayState } from "./types";

const initialState: DisplayState = {
    navigationBarVisible: true,
    //@ts-ignore
    upgradeModalDisplayProps: null
};

export function displayReducer(
    state = initialState,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action: any
): DisplayState
{
    switch (action.type)
    {
        case SET_NAVIGATION_BAR_VISIBILITY:
        {
            return {
                ...state,
                navigationBarVisible: action.payload
            }
        }

        case SET_UPGRADE_MODAL_DISPLAY_PROPS:
        {
            return {
                ...state,
                upgradeModalDisplayProps: action.payload
            }
        }

        case SET_UPGRADE_ACCOUNT_MODAL_VISIBILITY:
        {
            return {
                ...state,
                upgradeModalDisplayProps: {
                    ...state.upgradeModalDisplayProps,
                    visible: action.payload
                }
            }
        }

        default:
            return state;
    }
}
